import { VCol } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCol,{staticClass:"t-pt-6 t-pb-12 sm:t-py-10",attrs:{"cols":"12","md":"8","order":"2","order-md":"0"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }